export default __webpack_public_path__ + "static/media/installAndroid@2x.74db671d.png";